import { deleteAudit, getAudits } from 'store/actions/audit-action';
import { getUsers } from 'store/actions/user-action';
import { AppDispatch, RootState } from 'store/store';
import { Audit } from 'types/audit_types';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCustomers } from 'store/actions/customer-action';

export default () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const debounceTimer = useRef(null)

  const { audits, delete_loading } = useSelector((state: RootState) => state.audit);
  const { user } = useSelector((state: RootState) => state.common);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState<'create' | 'edit'>('create');
  const [selectedAudit, setSelectedAudit] = useState<Audit | null>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const pageSize = 20;

  useEffect(() => {
    dispatch(getAudits({ pageSize, pageNumber: page }));
    dispatch(getUsers({ pageSize: 50, pageNumber: 1 }));
    dispatch(getCustomers({ pageSize: 50, pageNumber: 1 }));
  }, []);

  const handleCreate = () => {
    setModalMode('create');
    setSelectedAudit(null);
    setIsModalOpen(true);
  };

  const handleEdit = (audit: Audit) => {
    setModalMode('edit');
    setSelectedAudit(audit);
    setIsModalOpen(true);
  };

  const onPageChange = (newPage: number = page) => {
    setPage(newPage);
    dispatch(getAudits({ pageSize, pageNumber: newPage }));
  };

  const onPressDelete = (item: Audit) => {
    setSelectedAudit(item);
    setDeleteModal(true);
  };

  const onConfimDelete = () => {
    const params = `${selectedAudit?.auditId}&deletedBy=${user?.userId}`;
    dispatch(
      deleteAudit(params, () => {
        setDeleteModal(false);
        dispatch(getAudits({ pageSize, pageNumber: page }));
      }),
    );
  };

  const onSearch = (val: string) => {
    setSearch(val)
    debounceTimer.current = setTimeout(() => {
      dispatch(getAudits({ pageSize, pageNumber: page, search: val }));
    }, 500);
  }

  return {
    audits,
    isModalOpen,
    modalMode,
    selectedAudit,
    handleCreate,
    handleEdit,
    setIsModalOpen,
    deleteModal,
    setDeleteModal,
    navigate,
    onPageChange,
    page,
    delete_loading,
    onPressDelete,
    onConfimDelete,
    setSearch,
    search,
    onSearch
  };
};
